module.exports = __webpack_public_path__ + "img/Group.9315407b.svg";